var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Box',{staticClass:"widget",attrs:{"background":_vm.background,"padding":"1"}},[_c('Stack',{attrs:{"space-unit":"1"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }